module.exports = __webpack_public_path__ + "static/media/manual_01.c26e0564.jpg";